import React, { useState, useRef, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BsX } from 'react-icons/bs';
import { Dropdown } from 'react-bootstrap';
import ReactTooltip from 'react-tooltip';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    CardHeader,
    CardTitle,
} from "reactstrap";
import { IoIosClose } from "react-icons/io";
import { Modal } from "react-bootstrap";
import { addCompany } from '../../stores/services/company.service';

function ViewCompany({ setViewModalFlag, selectedItems }) {
    const history = useHistory();
    const [showModal, setShowModal] = useState(false);
    const [companySignatoryModal, setCompanySignatoryModal] = useState(false);
    const amcCodeRegex = new RegExp('^[A-Z]{1,5}[A-Z]{1,5}$');
    const amc_code = sessionStorage.getItem("amc_code") || "";
    const [amcName, setAmcName] = useState('');
    const [amcCode, setAmcCode] = useState('');
    const [focalPerEmail, setFocalPerEmail] = useState('');
    const [focalPerName, setFocalPerName] = useState('');
    const [accTitle, setAccTitle] = useState('');
    const [accNo, setAccNo] = useState('');
    const [bankname, setBankName] = useState('');
    const [branchName, setBranchName] = useState('');
    const [revenueAuthority, setRevenueAuthority] = useState('');
    // const [amcSig, setAmcSig] = useState<any[]>([]);	
    const [conOffericer, setConOfficer] = useState('');
    const [Suboffericer, setSubOffericer] = useState('');
    const [txCreaterPop, setTxCreaterPop] = useState(false);
    let date = new Date();
    const [phone, setPhone] = useState('');
    const [mobile, setMobile] = useState('');
    const email = sessionStorage.getItem('email') || '';
    //foor Errors	
    const [amcNameError, setAmcNameError] = useState('');
    const [amcCodeError, setAmcCodeError] = useState('');
    const [focalPerEmailError, setFocalPerEmailError] = useState('');
    const [focalPerNameError, setFocalPerNameError] = useState('');
    const [amcSigError, setAmcSigError] = useState('');
    const [revenueAuthorityError, setRevenueAuthorityError] = useState('');
    const [conOffericerError, setConOfficerError] = useState('');
    const [SuboffericerError, setSubOffericerError] = useState('');
    const [txCreaterError, setTxCreaterError] = useState('');
    const [txExeError, setTxExeError] = useState('');
    const [phoneError, setPhoneError] = useState('');
    const [mobileError, setMobileError] = useState('');
    const [accTitleError, setAccTitleError] = useState('');
    const [accNoError, setAccNoError] = useState('');
    const [bankNameError, setBankNameError] = useState('');
    const [branchNameError, setBranchNameError] = useState('');
    const [billingName, setBillingName] = useState("");
    const [billingEmail, setBillingEmail] = useState("");
    const [billingDesignation, setBillingDesignation] = useState("");
    const [billingContactNumber, setBillingContactNumber] = useState("");
    const [Ntn, setNtn] = useState('')
    const [emailAdd, setEmailAdd] = useState('');
    const [nameCompanySignatory, setNameCompanySignatory] = useState('');
    const [emailCompanySignatory, setEmailCompanySignatory] = useState('');
    const [creatorEmailArray, setCreatorEmailArray] = useState<any>([]);
    const [billingNameErr, setBillingNameErr] = useState("");
    const [billingEmailErr, setBillingEmailErr] = useState("");
    const [billingDesignationErr, setBillingDesignationErr] = useState("");
    const [billingContactNumberErr, setBillingContactNumberErr] = useState("");
    const [NtnErr, setNtnErr] = useState('')
    const [name, setName] = useState<string>('');
    const [allBillingContact, setAllBillingContact] = useState<any>([]);
    const [modalView, setModalView] = useState(false);
    const [disableAddBtn, setDisableAddBtn] = useState<boolean>(false);
    const [fundTypeIs, setFundTypeIs] = useState<any>("");
    const [image, setImage] = useState<any>("");
    const [showImage, setShowImage] = useState<boolean>(false);

    useEffect(() => {
        if (selectedItems) {
            if (selectedItems?.company_logo) {
                setShowImage(true);
            }
            setImage(selectedItems?.company_logo || "");
            setAmcCode(selectedItems.company_code);
            setAmcName(selectedItems.name_of_company);
            setNtn(selectedItems.ntn);
            setAccTitle(selectedItems.account_title);
            setAccNo(selectedItems.IBAN);
            setCreatorEmailArray(selectedItems.txn_creator_field);
            setCompanySignatoryArray(selectedItems.amc_signatories);
            setFocalPerName(selectedItems.company_focal_name);
            setFocalPerEmail(selectedItems.company_focal_email);
            setMobile(selectedItems.mobile);
            setPhone(selectedItems.phone);
            setAllBillingContact(selectedItems.billing_contact);
            setFundTypeIs(selectedItems?.company_type)
        }
    }, [selectedItems]);

    const [emailArray, setEmailArray] = useState<any>([]);
    const [companySignatoryArray, setCompanySignatoryArray] = useState<any>([]);


    return (
        <>
            <div className="content">

                <Row>
                    <Col md="12">
                        <Container fluid>
                            <ToastContainer limit={1} />

                            <Row>
                                <Col md="4">
                                    <div className="card">
                                        <div className="card-header">
                                            <h4 className="card-title">
                                                Company Detail
                                            </h4>
                                        </div>
                                        <div className="card-body">
                                            <div className="d-flex justify-content-center">
                                                {image ? (
                                                    <div
                                                        style={{
                                                            width: "100px",
                                                            height: "100px",
                                                            position: "relative",
                                                        }}
                                                    >
                                                        <img
                                                            style={{
                                                                width: "100px",
                                                                height: "100px",
                                                            }}
                                                            className="User_image"
                                                            src={image}
                                                        />
                                                    </div>
                                                ) : (
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="100"
                                                        height="100"
                                                        viewBox="0 0 50 50"
                                                    >
                                                        <path
                                                            fill="#949494"
                                                            d="M25 2.008c-12.69 0-23 10.31-23 23s10.31 23 23 23 23-10.31 23-23-10.31-23-23-23m0 2c11.61 0 21 9.39 21 21a20.92 20.92 0 0 1-6.012 14.705c-1.83-1.343-4.06-2.017-5.949-2.69-1.064-.378-2.02-.753-2.719-1.171-.668-.4-1.04-.813-1.236-1.286-.092-1.146-.073-2.07-.066-3.16.12-.12.276-.205.4-.351.292-.345.59-.764.873-1.235.487-.807.84-1.795 1.04-2.797.302-.154.626-.187.872-.502.455-.58.762-1.396.899-2.533.12-1.004-.203-1.694-.62-2.224.449-1.465 1.003-3.795.815-6.205-.104-1.327-.438-2.662-1.24-3.772-.767-1.06-2.011-1.822-3.604-2.098C28.442 8.541 26.835 8 24.914 8h-.018c-4.302.079-7.078 1.86-8.267 4.576-1.13 2.583-.887 5.799-.076 9.147-.436.53-.778 1.233-.655 2.265.137 1.137.444 1.954.899 2.533.246.315.57.348.873.502.198 1.001.552 1.988 1.039 2.795.284.471.58.89.873 1.235.124.146.28.233.4.353.007 1.09.025 2.013-.066 3.16-.196.472-.567.884-1.234 1.286-.698.42-1.653.797-2.715 1.177-1.887.677-4.116 1.355-5.951 2.688A20.92 20.92 0 0 1 4 25.007c0-11.609 9.39-21 21-21m-.078 5.994c1.844.002 3.004.548 3.322 1.105l.244.428.487.067c1.256.174 1.958.662 2.46 1.357.503.695.783 1.666.868 2.756.17 2.18-.454 4.754-.85 5.945l-.252.756.682.414c-.07-.042.32.189.232.92-.106.89-.334 1.343-.486 1.537s-.218.17-.201.168l-.824.068-.088.823c-.076.706-.473 1.67-.938 2.441a8 8 0 0 1-.687.975c-.208.245-.43.397-.346.353l-.535.28V31c0 1.324-.054 2.407.086 3.95l.011.132.047.125c.394 1.06 1.215 1.806 2.139 2.36s1.983.952 3.076 1.341c1.801.641 3.678 1.272 5.11 2.203A20.9 20.9 0 0 1 25 46.008c-5.134 0-9.829-1.84-13.475-4.893 1.44-.926 3.32-1.559 5.118-2.203 1.092-.391 2.149-.793 3.07-1.348.921-.554 1.74-1.301 2.133-2.357l.047-.125.011-.133c.139-1.54.086-2.624.086-3.949v-.605l-.535-.282c.084.044-.138-.108-.346-.353a8 8 0 0 1-.687-.973c-.465-.771-.862-1.736-.938-2.441l-.088-.823-.824-.068c.016.001-.049.026-.2-.168-.153-.194-.38-.647-.487-1.537-.088-.732.307-.965.232-.92l.635-.385-.186-.72c-.86-3.312-.99-6.325-.105-8.348.884-2.02 2.655-3.303 6.46-3.375"
                                                        ></path>
                                                    </svg>
                                                )}
                                            </div>
                                            <div className="form-group  ">
                                                <div>
                                                    <label>
                                                        Type
                                                    </label>
                                                </div>
                                                <div>
                                                    <div className=" ">
                                                        <input
                                                            type="text"
                                                            className={`form-control  w-100 `}
                                                            value={fundTypeIs}
                                                            readOnly
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group  ">
                                                <div>
                                                    <label>
                                                        Company Code <span className="color-amber">*</span>
                                                    </label>
                                                </div>
                                                <div>
                                                    <div className=" ">
                                                        <input
                                                            type="text"
                                                            className={`form-control  w-100 `}
                                                            value={amcCode}
                                                            readOnly
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group  ">
                                                <label>Name of Company <span className="color-amber">*</span></label>
                                                <div className=" ">
                                                    <input
                                                        type="text"
                                                        className={`form-control  w-100 `}
                                                        value={amcName}
                                                        readOnly
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-group  ">
                                                <label>NTN </label>
                                                <div className="">
                                                    <input
                                                        type="text"
                                                        className={`form-control  w-100 `}
                                                        value={Ntn}
                                                        readOnly
                                                    />
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </Col>

                                <Col md="4">
                                    <div className="card">
                                        <div className="card-header">
                                            <h4 className="card-title">
                                                Bank Details
                                            </h4>
                                        </div>
                                        <div className="card-body">
                                            <div className="form-group  ">
                                                <label>Account Title <span className="color-amber">*</span></label>
                                                <div className="">
                                                    <input
                                                        type="text"
                                                        className={`form-control  w-100 `}
                                                        value={accTitle}
                                                        readOnly
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-group  ">
                                                <label>IBAN<span className="color-amber">*</span></label>
                                                <div className="">
                                                    <input
                                                        type="text"
                                                        className={`form-control  w-100 `}
                                                        value={accNo}
                                                        readOnly
                                                    />
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                </Col>

                                <Col md="4">
                                    <div className="card">
                                        <div className="card-header">
                                            <h4 className="card-title">
                                                Authorized Company Users
                                            </h4>
                                        </div>
                                        <div className="card-body">

                                            <div className="form-group ">
                                                <label>Transaction Creator Field <span className="color-amber">*</span></label>
                                                <div className="multi-input">
                                                    <div
                                                        className={`d-flex  w-100 ${amcSigError ? 'required-border' : ''
                                                            }`}
                                                    >
                                                        <Dropdown>
                                                            <Dropdown.Toggle
                                                                className="input-sign"
                                                                variant="success"
                                                                id="dropdown-basic"
                                                            >
                                                                {creatorEmailArray.length} Added
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu>
                                                                {creatorEmailArray.map((obj: any, i: any) => (
                                                                    <Dropdown.Item className="drop-item " key={i}>
                                                                        <div className="d-flex justify-content-between">
                                                                            <div className="mr-auto">{obj.email}</div>

                                                                        </div>
                                                                    </Dropdown.Item>
                                                                ))}
                                                            </Dropdown.Menu>
                                                        </Dropdown>

                                                    </div>
                                                </div>
                                            </div>

                                            <div className="form-group  ">
                                                <label>Company Signatories <span className="color-amber">*</span></label>
                                                <div className="multi-input">
                                                    <div
                                                        className={`d-flex  w-100 ${amcSigError ? 'required-border' : ''
                                                            }`}
                                                    >
                                                        <Dropdown>
                                                            <Dropdown.Toggle
                                                                className="input-sign"
                                                                variant="success"
                                                                id="dropdown-basic"
                                                            >
                                                                {companySignatoryArray?.length} Added
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu>
                                                                {companySignatoryArray?.map((obj: any, i: any) => (
                                                                    <Dropdown.Item className="drop-item " key={i}>
                                                                        <div className="d-flex justify-content-between" style={{ fontSize: '15px' }}>
                                                                            <div
                                                                                className="mr-auto"
                                                                                style={{ fontSize: '15px' }}
                                                                            >
                                                                                <span style={{ color: 'green' }}>
                                                                                    Sig{obj?.role?.slice(-1)}
                                                                                </span>{' '}
                                                                                {obj?.email}
                                                                            </div>

                                                                        </div>
                                                                    </Dropdown.Item>
                                                                ))}
                                                            </Dropdown.Menu>
                                                        </Dropdown>

                                                    </div>
                                                </div>
                                            </div>



                                            {/* <div className="form-group  ">
                                                <label>Concerned Officer {' '} <span className="color-amber">*</span></label>
                                                <div className="">
                                                    <select
                                                        className={`form-control  w-100 `}
                                                        value={conOffericer}
                                                        disabled
                                                    >
                                                        <option value="" defaultChecked hidden>
                                                            Select Officer
                                                        </option>
                                                        {renderofficersDropdown()}
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="form-group  ">
                                                <label>Substitute Concerned Officer <span className="color-amber">*</span></label>
                                                <div className=" ">
                                                    <select
                                                        className={`form-control  w-100 ${SuboffericerError ? 'required-border' : ''
                                                            }`}
                                                        value={Suboffericer}
                                                        disabled
                                                    >
                                                        <option value="" defaultChecked hidden>
                                                            Select Substitute
                                                        </option>
                                                        {renderSubOfficerDropdown()}
                                                    </select>
                                                </div>
                                            </div> */}

                                        </div>
                                    </div>
                                </Col>

                            </Row>

                            <Row>
                                <Col md="4">
                                    <div className="card">
                                        <div className="card-header">
                                            <h4 className="card-title">
                                                Focal Person Detail
                                            </h4>
                                        </div>
                                        <div className="card-body">
                                            <div className="form-group  ">
                                                <label>Company Focal Person Name</label>
                                                <div className="">
                                                    <input
                                                        type="text"
                                                        className={`form-control  w-100 `}
                                                        value={focalPerName}
                                                        readOnly
                                                    />
                                                    {/* {focalPerNameError ? <p className="error-labels error-message2">{focalPerNameError}</p> : ''} */}
                                                </div>
                                            </div>

                                            <div className="form-group  ">
                                                <label>Company Focal Person Email</label>
                                                <div className="">
                                                    <input
                                                        type="text"
                                                        className={`form-control  w-100 `}
                                                        value={focalPerEmail}
                                                        readOnly
                                                    />
                                                    {/* {focalPerEmailError ? <p className="error-labels error-message">{focalPerEmailError}</p> : ''} */}
                                                </div>
                                            </div>

                                            <div className="form-group  ">
                                                <label>Mobile</label>
                                                <div className="">
                                                    <input
                                                        type="number"
                                                        className={`form-control  w-100 `}
                                                        value={mobile}
                                                        readOnly
                                                    />
                                                    {/* {mobileError ? <p className="error-labels error-message2">{mobileError}</p> : ''} */}
                                                </div>
                                            </div>

                                            <div className="form-group  ">
                                                <label>Phone</label>
                                                <div className="">
                                                    <input
                                                        type="number"
                                                        className={`form-control  w-100 `}
                                                        value={phone}
                                                        readOnly
                                                    />
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </Col>

                            </Row>

                        </Container>
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default ViewCompany